import PropTypes from 'prop-types';
import React, { memo } from 'react';
import ModuleWrapper from '../../../components/ui/ModuleWrapper/ModuleWrapper';
import InformationBoxStyles from './InformationBox.style';

/**
 * Information Box component to display title, description and search term
 * @param {Object} props - Component props
 * @param {string} props.title - Title text
 * @param {string} props.description - Description text
 * @param {string} [props.term] - Optional search term
 * @returns {React.ReactElement} The InformationBox component
 */
const InformationBox = ({ title, description, term }) => {
  const decodedTerm = term ? decodeURIComponent(term) : '';

  return (
    <ModuleWrapper>
      <div className="information-box-container-mkp" data-testid="information-box">
        <div className="mkp-block">
          <h3>
            {title} {term && <span data-testid="search-term">&apos;{decodedTerm}&apos;</span>}
          </h3>
          <p>{description}</p>
        </div>
        <style jsx>{InformationBoxStyles}</style>
      </div>
    </ModuleWrapper>
  );
};

InformationBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  term: PropTypes.string,
};

InformationBox.defaultProps = {
  term: '',
};

export default memo(InformationBox);
